import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import * as _ from 'underscore';

import { Messages } from '../../../codegen/Localize';
import { AddUsersOptionsAction } from '../../../ts/services/AddUsersOptionsAction';
import { SiteUserAddUsers } from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { SiteUserAddAction } from '../../actions/spaces/SiteUserMenuActions';
import { ServiceLocator } from '../../ServiceLocator';
import { reloadSpace } from './content/RefreshContentSagas';

export function addUsers() {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<AddUsersOptionsAction>('AddUsersOptionsAction')
    .showAddSiteUsersOptionsDialog(context);
}

export function* handleAddUsers(action: SiteUserAddAction): SagaIterator {
  try {
    yield call(addUsers);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootSiteUserMenuActionSaga(): SagaIterator {
  yield takeEvery(SiteUserAddUsers, handleAddUsers);
}
